const extensionActionTypes = {
    RETRIEVED_INSTALLED_PACKAGES: "RETRIEVED_INSTALLED_PACKAGES",
    RETRIEVED_AVAILABLE_PACKAGES: "RETRIEVED_AVAILABLE_PACKAGES",
    UPDATED_EXTENSION: "UPDATED_EXTENSION",
    ADDED_NEW_EXTENSION: "ADDED_NEW_EXTENSION",
    DELETED_EXTENSION: "DELETED_EXTENSION",
    TOGGLE_DELETE_EXTENSION_FILES: "TOGGLE_DELETE_EXTENSION_FILES",
    SET_EXTENSION_BEING_DELETED: "SET_EXTENSION_BEING_DELETED",
    EDIT_EXTENSION: "EDIT_EXTENSION",
    RETRIEVED_INSTALLED_PACKAGE_TYPES: "RETRIEVED_INSTALLED_PACKAGE_TYPES",
    RETRIEVED_AVAILABLE_PACKAGE_TYPES: "RETRIEVED_AVAILABLE_PACKAGE_TYPES",
    CREATED_NEW_MODULE: "CREATED_NEW_MODULE",
    UPDATED_EXTENSION_BEING_EDITED: "UPDATED_EXTENSION_BEING_EDITED",
    TOGGLE_TRIED_TO_SAVE: "TOGGLE_TRIED_TO_SAVE",
    TOGGLE_TAB_ERROR: "TOGGLE_TAB_ERROR",
    RETRIEVED_MODULE_CATEGORIES: "RETRIEVED_MODULE_CATEGORIES",
    INSTALLED_EXTENSION: "INSTALLED_EXTENSION",
    PARSED_AVAILABLE_PACKAGE: "PARSED_AVAILABLE_PACKAGE",
    SELECT_EDITING_TAB: "SELECT_EDITING_TAB",
    RETRIEVED_LOCALE_LIST: "RETRIEVED_LOCALE_LIST",
    RETRIEVED_PACKAGE_LOCALE_LIST: "RETRIEVED_PACKAGE_LOCALE_LIST",
    DEPLOYED_AVAILABLE_PACKAGE: "DEPLOYED_AVAILABLE_PACKAGE",
    RETRIEVED_PACKAGE_USAGE_FILTER: "RETRIEVED_PACKAGE_USAGE_FILTER",
    RETRIEVED_PACKAGE_USAGE: "RETRIEVED_PACKAGE_USAGE"
};
export default extensionActionTypes;